import protectedComponent from 'components/helpers/protectedComponent';

export default protectedComponent(() => import('./Admin'),
  // {
  //   action: 'ADMIN_SETTINGS_VIEW'
  // }
);
